import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createPartnerStaff } from '../../api/partner-staff.ts';
import type { CreatePartnerStaffRequest } from '../../api/requests/partner-staff-request.ts';

export default function useCreatePartnerStaff(): UseMutationResult<
  string,
  Error,
  CreatePartnerStaffRequest
> {
  return useMutation({ mutationFn: createPartnerStaff });
}
